import { css } from "@emotion/react";

export const BettingHistoryPageStyle = {
  wrapper: css`
    background-color: transparent;

    padding: 0 15px 8px 15px;
  `,
  mainContent: css`
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
  `,
};
